module.exports = __webpack_public_path__ + "img/9.a9562a93.png";